import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ClientTimeOffRequestService } from '../../../services/time-off-request.service';
import {
  EditedRecord,
  PendingTimeOffRequest,
  RequestTypes,
  TimeOffRecord
} from '../../../models/TimeOffModels';
import { Select, Store } from '@ngxs/store';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';
import { NgbModal, NgbModalRef, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { AreDatesEqual } from '../../../utils/dateUtils';
import { Option } from '../../../components/multiselect/multiselect.component';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { BehaviorSubject, merge, Observable, OperatorFunction, Subject } from 'rxjs';
import { Person } from '../../../models/person';
import { debounceTime, distinctUntilChanged, filter, map, mergeMap } from 'rxjs/operators';
import { PeopleService } from '../../../services/people.service';
import {
  TimeOffLoadPeriodStartDate,
  TimeOffLoadRequests,
  TimeOffRemoveFilter,
  TimeOffRequestsState,
  TimeOffSetFilters,
  TimeOffSetSearchTerm
} from '../../../state/TimeOffRequestsState/TimeOffRequests.state';

@Component({
  selector: 'lib-client-time-off-home',
  templateUrl: './client-time-off-home.component.html',
  styleUrls: ['./client-time-off-home.component.css'],
  standalone: false
})
export class ClientTimeOffHomeComponent implements OnInit {
  @ViewChild('newRequestModal', { static: true })
  public newRequestModalContent: TemplateRef<any>;
  public showNewRequestModal: boolean = false;
  public newRequestModalRef: NgbModalRef;
  @ViewChild('createNewModal', { static: true })
  public createNewModalContent: TemplateRef<any>;
  public showCreateNewModal: boolean = false;
  public createNewModalRef: NgbModalRef;

  @ViewChild('approvedModal', { static: true })
  public approvedModalContent: TemplateRef<any>;
  public showApprovedModal: boolean = false;
  public approvedModalRef: NgbModalRef;

  @ViewChild('editedRequestModal', { static: true })
  public editedRequestModalContent: TemplateRef<any>;
  public showEditedRequestModal: boolean = false;
  public editedRequestModalRef: NgbModalRef;

  public clientCode: string;

  public requests: PendingTimeOffRequest[] = [];

  @Select(TimeOffRequestsState.getOpenRequests)
  public openRequests: Observable<PendingTimeOffRequest[]>;

  @Select(TimeOffRequestsState.getApprovedRequests)
  public approvedRequests: Observable<TimeOffRecord[]>;

  @Select(TimeOffRequestsState.getEditedRequests)
  public editedRequests: Observable<EditedRecord[]>;
  @Select(TimeOffRequestsState.getDeletedRequests)
  public deletedRequests: Observable<TimeOffRecord[]>;
  public currentEditedRequest: EditedRecord = null;
  public currentRequest: PendingTimeOffRequest = null;
  public currentApprovedRequest: TimeOffRecord = null;

  @Select(TimeOffRequestsState.getPendingRequestCount)
  public pendingRequestCount: Observable<number>;

  @Select(TimeOffRequestsState.getPendingChangesCount)
  public pendingChangesCount: Observable<number>;

  @Select(TimeOffRequestsState.getDeclinedCount)
  public declinedCount: Observable<number>;

  @Select(TimeOffRequestsState.getApprovedCount)
  public approvedCount: Observable<number>;

  public requestsToShow: Observable<PendingTimeOffRequest[]> | null = null;
  public approvedToShow: Observable<TimeOffRecord[]> | null = null;
  public deletedToShow: Observable<TimeOffRecord[]> | null = null;
  public editedToShow: Observable<EditedRecord[]> | null = null;
  public tableheader: string = null;
  public searchTerm: any;

  @Select(TimeOffRequestsState.getCurrentFilters)
  public currentFilters: Observable<string[]>;

  public statusFilter: Option[] = [
    {
      value: 'Requested',
      text: 'Requested'
    },
    {
      value: 'Pending',
      text: 'Pending'
    },
    {
      value: 'Approved',
      text: 'Approved'
    },
    {
      value: 'Declined',
      text: 'Declined'
    }
  ];

  public defaultDay: Date | null = null;

  //Date currently viewed in the calendar
  public viewDate: Date = new Date();

  @Select(TimeOffRequestsState.getFilteredCalendarEvents)
  public events: Observable<CalendarEvent[]>;

  public filteredEvents: BehaviorSubject<CalendarEvent[]>;

  public showDayView = false;

  //refreshes the calendar when it emits
  refresh = new Subject<void>();
  //Shows details for day
  activeDayIsOpen = false;
  get isDateInMonth() {
    return this.viewDate.getMonth() == new Date().getMonth();
  }

  public colors: any = {
    history: {
      primary: '#D9D9D9',
      secondary: '#D9D9D9'
    },
    requested: {
      primary: '#FFC107',
      secondary: '#ffe8a3'
    },
    pendingChange: {
      primary: '#DC3545',
      secondary: '#DC3545'
    },
    approved: {
      primary: '#6AAA37',
      secondary: '#6AAA37'
    }
  };

  constructor(
    private clientTimeOffService: ClientTimeOffRequestService,
    private store: Store,
    private ngModal: NgbModal,
    private peopleService: PeopleService
  ) {}

  ngOnInit() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
      this.clientCode = code;
      this._loadTable();
    });
  }

  public eventClicked(args) {
    if (args.meta.Approved && args.meta.EditedByApprover) {
      this.openEditedModal(args.meta);
    } else if (args.meta.Approved) {
      this.openApprovedModal(args.meta);
    } else if (args.meta.Removed) {
      this.openApprovedModal(args.meta);
    } else {
      this.openNewRequestModal(args.meta);
    }
  }
  public openEditedModal(item: EditedRecord) {
    this.currentEditedRequest = item;
    this.showEditedRequestModal = true;
    this.editedRequestModalRef = this.ngModal.open(this.editedRequestModalContent, {
      size: 'lg',
      windowClass: 'centered',
      backdrop: 'static',
      keyboard: false
    });
  }
  public dayClicked(args: Date): void {
    this.defaultDay = args;
    this.submitNewRequest();
  }

  public submitNewRequest() {
    this.showCreateNewModal = true;
    this.createNewModalRef = this.ngModal.open(this.createNewModalContent, {
      size: 'lg',
      windowClass: 'centered',
      backdrop: 'static',
      keyboard: false
    });
  }

  public openNewRequestModal(item: PendingTimeOffRequest) {
    this.currentRequest = item;
    this.showNewRequestModal = true;
    this.newRequestModalRef = this.ngModal.open(this.newRequestModalContent, {
      size: 'lg',
      windowClass: 'centered',
      backdrop: 'static',
      keyboard: false
    });
  }
  public openApprovedModal(item: TimeOffRecord) {
    this.currentApprovedRequest = item;
    this.showApprovedModal = true;
    this.approvedModalRef = this.ngModal.open(this.approvedModalContent, {
      size: 'lg',
      windowClass: 'centered',
      backdrop: 'static',
      keyboard: false
    });
  }

  @ViewChild('typeahead') typeahead: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  search: OperatorFunction<string, readonly Person[]> = text => {
    const debouncedText = text.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup = this.click$.pipe(filter(() => !this.typeahead.isPopupOpen()));
    const inputFocus = this.focus$;

    return merge(debouncedText, inputFocus, clicksWithClosedPopup).pipe(
      debounceTime(200),
      mergeMap(term => {
        return this.peopleService.searchPeople(this.clientCode, {
          query: term
        });
      }),
      map(result => {
        return result.Items;
      })
    );
  };
  formatter = (x: Person) => `${x.FirstName} ${x.LastName}`;
  public reviewRequestFromTable(item: PendingTimeOffRequest) {
    this.openNewRequestModal(item);
  }
  public reviewApprovedRequestFromTable(item: TimeOffRecord) {
    this.openApprovedModal(item);
  }
  public searchChanged(test) {
    this.store.dispatch(new TimeOffSetSearchTerm(test));
  }

  public closeNewRequestModal() {
    this.showCreateNewModal = false;
    this.createNewModalRef?.dismiss();
    this.currentRequest = null;
    this.newRequestModalRef?.dismiss();
    this.showNewRequestModal = false;
    this.approvedModalRef?.dismiss();
    this.showApprovedModal = false;
    this.editedRequestModalRef?.dismiss();
    this.showEditedRequestModal = false;
    this.currentEditedRequest = null;
    this._loadTable();
  }
  clearFiltersClicked() {
    this.store.dispatch(new TimeOffSetFilters([]));
  }

  filterPillClicked(pill) {
    this.store.dispatch(new TimeOffRemoveFilter(pill));
  }

  statusFilterChange(event) {
    this.store.dispatch(new TimeOffSetFilters(event));
  }

  public showPendingTable() {
    this.approvedToShow = null;
    this.deletedToShow = null;
    this.tableheader = 'Pending Requests';
    this.requestsToShow = this.openRequests.pipe(
      map(x => x.filter(y => y.EditedByRequester || y.Pending))
    );
  }
  public showPendingChangeTable() {
    this.approvedToShow = null;
    this.deletedToShow = null;
    this.editedToShow = this.editedRequests;
    this.tableheader = 'Pending Changes';
    this.requestsToShow = this.openRequests.pipe(map(x => x.filter(y => y.EditedByApprover)));
  }
  public showDeclinedTable() {
    this.approvedToShow = null;
    this.deletedToShow = this.deletedRequests;
    this.tableheader = 'Declined';
    this.requestsToShow = this.openRequests.pipe(map(x => x.filter(y => y.Declined)));
  }
  public showApprovedTable() {
    this.requestsToShow = null;
    this.deletedToShow = null;
    this.approvedToShow = this.approvedRequests;
  }

  public showCalendar() {
    this.requestsToShow = null;
    this.approvedToShow = null;
  }

  public parseEventList(events: CalendarEvent[]) {
    const maxEvents = 3;
    if (events.length <= maxEvents) return { events: events, showMore: false };
    const multidayEvents: CalendarEvent[] = [];
    const otherEvents: CalendarEvent[] = [];
    events.forEach(event => {
      if (event.meta.TimeOffRequestType == RequestTypes.MultipleDays) {
        multidayEvents.push(event);
      } else {
        otherEvents.push(event);
      }
    });
    if (multidayEvents.length < maxEvents) {
      //add other events to fill
      for (let i = 0; multidayEvents.length < maxEvents; i++) {
        if (otherEvents.length > i + 1) {
          multidayEvents.push(otherEvents[i]);
        } else {
          break;
        }
      }
    }
    return { events: multidayEvents.sort(this.sortEvents), showMore: true };
  }

  public showMore(day) {
    this.viewDate = day.date;
    this.showDayView = true;
  }
  public hideDayView() {
    this.showDayView = false;
  }

  public getDayViewEventBackground(event) {
    if (event.meta.EditedByApprover) {
      return '#FFF';
    } else if (event.meta.Pending || event.meta.EditedByRequester) {
      return '#DC8835';
    } else if (event.meta.Approved) {
      return '#6aaa37';
    } else if (event.meta.Declined) {
      return '#DC3545';
    }
    return '';
  }

  public getDayViewEventTextColor(event) {
    if (event.meta.EditedByApprover) {
      return '#DC8835';
    } else if (event.meta.Pending || event.meta.EditedByRequester) {
      return '#FFF';
    } else if (event.meta.Approved) {
      return '#FFF';
    } else if (event.meta.Declined) {
      return '#FFF';
    }
    return '';
  }

  public getDayViewEventBorder(event) {
    if (event.meta.EditedByApprover) {
      return '#DC8835';
    } else if (event.meta.Pending || event.meta.EditedByRequester) {
      return '#DC8835';
    } else if (event.meta.Approved) {
      return '#6aaa37';
    } else if (event.meta.Declined) {
      return '#DC3545';
    }
    return '';
  }

  private _loadTable() {
    this.store.dispatch(new TimeOffLoadPeriodStartDate());
    this.store.dispatch(new TimeOffLoadRequests(this.clientCode)).subscribe(_ => {
      this.refresh.next();
    });
  }

  private sortEvents(a, b) {
    if (
      a.meta.TimeOffRequestType == RequestTypes.PartialDay &&
      b.meta.TimeOffRequestType != RequestTypes.PartialDay
    ) {
      return -1;
    }
    if (
      b.meta.TimeOffRequestType == RequestTypes.PartialDay &&
      a.meta.TimeOffRequestType != RequestTypes.PartialDay
    ) {
      return 1;
    }
    if (
      a.meta.TimeOffRequestType == RequestTypes.MultipleDays &&
      b.meta.TimeOffRequestType != RequestTypes.MultipleDays
    ) {
      return 1;
    }
    if (
      a.meta.TimeOffRequestType != RequestTypes.MultipleDays &&
      b.meta.TimeOffRequestType == RequestTypes.MultipleDays
    ) {
      return -1;
    }
    return 0;
  }

  protected readonly RequestTypes = RequestTypes;
  protected readonly AreDatesEqual = AreDatesEqual;
  protected readonly CalendarView = CalendarView;
}
